export default "__VITE_ASSET__BqWt_sDm__"